import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('CONTRACTS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class ContractsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'contracts' como el nombre del recurso a la clase base
    super('contracts');
    log.debug('Servicio de Contratos inicializado');
  }

}